import { useTranslation } from 'react-i18next';
import { use24h } from '@utils/consts';
import { fromParts12, getMinuteOptions, pad, toParts } from '../timePicker/helpers';
import { ITEM_HEIGHT, VISIBLE_ITEMS } from './constants';
import { WheelColumn } from './column';
import { TimeWheelProps } from './types';

const HOURS_12 = Array.from({ length: 12 }, (_, i) => i + 1);
const HOURS_24 = Array.from({ length: 24 }, (_, i) => i);
const PERIODS = ['AM', 'PM'] as const;

export const TimeWheel = ({ label, value, onChange }: TimeWheelProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'scheduling.time' });
  const parts = toParts(value);

  return (
    <div
      data-vaul-no-drag
      className="relative flex justify-center gap-1 [mask-image:linear-gradient(to_bottom,transparent,black_30%,black_70%,transparent)]"
      style={{ height: ITEM_HEIGHT * VISIBLE_ITEMS }}>
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-2 top-1/2 -translate-y-1/2 rounded-lg bg-neutral-100"
        style={{ height: ITEM_HEIGHT }}
      />
      <WheelColumn
        label={t('hour', { label })}
        className="w-20"
        options={(use24h ? HOURS_24 : HOURS_12).map((hour) => ({
          value: hour,
          label: use24h ? pad(hour) : String(hour),
        }))}
        value={use24h ? parts.hours : parts.hours12}
        onChange={(hour) =>
          onChange(
            use24h ? hour * 60 + parts.minutes : fromParts12(hour, parts.minutes, parts.period),
          )
        }
      />
      <span
        aria-hidden
        className="relative z-10 self-center text-xl font-semibold text-neutral-800">
        :
      </span>
      <WheelColumn
        label={t('minutes', { label })}
        className="w-20"
        options={getMinuteOptions(parts.minutes).map((minute) => ({
          value: minute,
          label: pad(minute),
        }))}
        value={parts.minutes}
        onChange={(minute) => onChange(parts.hours * 60 + minute)}
      />
      {!use24h && (
        <WheelColumn
          label={t('period', { label })}
          className="w-20"
          options={PERIODS.map((period) => ({ value: period, label: period }))}
          value={parts.period}
          onChange={(period) => onChange(fromParts12(parts.hours12, parts.minutes, period))}
        />
      )}
    </div>
  );
};
